import { z } from 'zod';

export const storeProfileSchema = z.object({
  name: z.string().min(2).max(100),
  description: z.string().max(500).optional(),
  mall: z.string().min(1, 'Select a mall'),
  floor: z.string().min(1),
  unit: z.string().min(1),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  categories: z.array(z.string()).min(1, 'Select at least one category'),
  brands: z.array(z.string()),
  availableSizes: z.object({
    tops: z.array(z.string()).optional(),
    bottoms: z.array(z.string()).optional(),
    shoes: z.array(z.number()).optional(),
  }),
  operatingHours: z.array(
    z.object({
      day: z.enum(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']),
      open: z.string(),
      close: z.string(),
      closed: z.boolean(),
    })
  ),
});

export type StoreProfileFormData = z.infer<typeof storeProfileSchema>;
